<template>
  <div class="text-center">
    <div class="spinner mx-auto"></div>
  </div>
</template>
<script setup></script>
<style scoped>
.spinner {
  border: 8px solid rgba(0, 0, 0, 0.1); /* Light border */
  border-left-color: #b6300f; /* Primary color for the spinner */
  border-radius: 50%;
  width: 50px; /* Spinner size */
  height: 50px; /* Spinner size */
  animation: spin 1s linear infinite; /* Spin animation */
  margin-bottom: 20px; /* Space between spinner and text */
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
